/*
 * ca-buybar.js — mobile sticky buy bar
 * ---------------------------------------------------------------------------
 * The bar owns no cart logic. It is a proxy:
 *   - it finds the real primary control (Add to cart, or the pre-order button
 *     once the pre-order app has replaced it)
 *   - it mirrors that control's label and disabled state
 *   - clicking it clicks the real control
 *
 * So variant changes, sold-out states, pre-order takeover and any app that
 * swaps the button all keep working with no duplicated behaviour.
 *
 * Visibility: shown only once the real buy block has scrolled out of view, so
 * it never covers the control it is standing in for.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-ca-buybar]');
  if (!bar) return;

  var cta = bar.querySelector('[data-ca-buybar-cta]');
  var anchor = document.querySelector('.qty-atc-row') ||
               document.querySelector('.product__info-container .product-form') ||
               document.querySelector('.product-form__buttons');
  if (!cta || !anchor) return;

  function realControl() {
    var preorder = document.querySelector(
      '.ca-preorder-block button, .product__info-container [class*="globo"] button, .product__info-container .globo-preorder-button'
    );
    if (preorder && preorder.offsetParent !== null) return preorder;
    return document.querySelector('.product-form__submit');
  }

  function label(el) {
    /* Prefer the button's own text span; Dawn hides a second sold-out span. */
    var span = el.querySelector('span:not(.sold-out-message):not(.visually-hidden)');
    var text = (span ? span.textContent : el.textContent) || '';
    return text.replace(/\s+/g, ' ').trim();
  }

  function sync() {
    var real = realControl();
    if (!real) { bar.setAttribute('hidden', 'hidden'); return; }

    var text = label(real);
    if (text && cta.textContent.trim() !== text) cta.textContent = text;

    var off = real.hasAttribute('disabled') || real.getAttribute('aria-disabled') === 'true';
    cta.disabled = off;
    cta.classList.toggle('is-disabled', off);
  }

  cta.addEventListener('click', function (e) {
    e.preventDefault();
    var real = realControl();
    if (real && !cta.disabled) real.click();
  });

  /* Show the bar only after the real buy block has left the viewport. */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible) {
        bar.setAttribute('hidden', 'hidden');
      } else {
        bar.removeAttribute('hidden');
        sync();
      }
    }, { rootMargin: '0px 0px -40% 0px' }).observe(anchor);
  } else {
    bar.removeAttribute('hidden');
    sync();
  }

  /* Variant swaps, pre-order takeover, app re-renders. */
  new MutationObserver(sync).observe(
    document.querySelector('.product__info-container') || document.body,
    { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] }
  );

  sync();
})();
